export default {"src":"/_next/static/media/whypod-icon2.c358b60d.svg","height":51,"width":50};